import { useEffect } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Editor from './pages/editor'
import List from './pages/list'
import { ErrorPage } from './pages/errorPage'
import { isSupportedDevice, isTabletDevice } from './utils/deviceDetector'
import { UserProvider } from './components/user/provider'
import { UnsupportedDeviceError } from './components/unsupportedDeviceError'

const DeviceCheck = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === '/unsupported' || isSupportedDevice()) {
      return
    }
    // タブレットはチュートリアル対象ミッション（RJF01 等）に限りエディタを
    // 利用できる。ミッションの判定には API 応答（missionInfo）が必要なため、
    // ここでは弾かずエディタ側のガード（editor.tsx）に委ねる。
    if (isTabletDevice() && location.pathname === '/') {
      return
    }
    navigate('/unsupported')
  }, [navigate, location.pathname])

  return <>{children}</>
}

export const App = () => {
  return (
    <BrowserRouter>
      <UserProvider>
        <DeviceCheck>
          <Routes>
            <Route path="/unsupported" element={<UnsupportedDeviceError />} />
            <Route path="/" element={<Editor />} />
            <Route path="/list" element={<List />} />
            <Route
              path="/*"
              element={
                <ErrorPage
                  title="404 Not Found"
                  description="ページがみつかりません"
                  buttonLabel="トップへもどる"
                  linkTo="リスト"
                />
              }
            />
          </Routes>
        </DeviceCheck>
        <ToastContainer closeOnClick position="bottom-left" />
      </UserProvider>
    </BrowserRouter>
  )
}
